var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgGrTitle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 388,
    height: 108,
    viewBox: "0 0 388 108",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fontFamily: "TTNormsPro-Bold, TT Norms Pro",
    fontSize: 32,
    fontWeight: "bold",
    letterSpacing: 0.5
  }, /*#__PURE__*/React.createElement("text", {
    transform: "translate(-526.000000, -240.000000) translate(526.000000, 240.000000) translate(128.000000, 17.000000)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 30
  }, "GoShare"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 67,
    fontFamily: "PingFangTC-Semibold, PingFang TC",
    fontWeight: 500
  }, "\u5171\u4EAB\u904B\u5177\u8CC7\u8A0A\u5E73\u53F0"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M54 0c29.823 0 54 24.177 54 54s-24.177 54-54 54C24.176 108 0 83.823 0 54S24.176 0 54 0zM29.815 72.566c-2.286 0-3.735 1.448-3.735 3.125 0 3.812 5.26 2.669 5.26 4.65 0 .762-.61 1.372-1.754 1.372-1.6 0-2.515-1.143-2.515-1.143l-1.372 1.372.02.024c.175.21 1.536 1.73 4.02 1.73 2.592 0 4.04-1.449 4.04-3.355 0-3.811-5.26-2.668-5.26-4.65 0-.61.534-1.143 1.45-1.143 1.218 0 1.98.915 1.98.915l1.372-1.449s-1.143-1.448-3.506-1.448zm25.671.229h-2.439l-4.193 10.672h2.44l.914-2.516h4.116l.915 2.516h2.44l-4.193-10.672zm-16.22 0h-2.287v10.672h2.287v-4.345h4.574v4.345h2.286V72.795H43.84v4.268h-4.574v-4.268zm27.805 0h-4.726v10.672h2.287v-3.735h1.982l2.058 3.735h2.44l-2.287-4.04.06-.03.1-.054c.46-.262 1.746-1.163 1.746-3.042 0-1.951-1.525-3.506-3.66-3.506zm14.787 0h-7.851v10.671h8.004v-2.058h-5.718v-2.363h4.345v-2.058h-4.345v-2.134h5.565v-2.058zm-27.592 2.668l1.296 3.506h-2.591l1.295-3.506zm12.73-.61c.838 0 1.447.61 1.447 1.448 0 .762-.609 1.372-1.448 1.372h-2.363v-2.82zm2.681-37.122c-7.507 0-13.614 6.107-13.614 13.615 0 7.507 6.107 13.615 13.614 13.615 7.508 0 13.615-6.108 13.615-13.615 0-7.508-6.107-13.615-13.615-13.615zm-30.98-19.593h-.32c-7.604.087-13.67 6.401-13.67 14.007v18.808l.004.312c.163 7.475 6.182 13.623 13.692 13.696 7.689.074 13.968-6.16 13.968-13.832v-5.413h.01v-7.253l-.008-.063c-.028-.12-.136-.21-.266-.21H39.01l-.088.007c-.26.042-.458.267-.458.539v6.434l.007.089c.043.26.268.457.54.457h4.94v5.305l-.004.215c-.114 2.933-2.546 5.355-5.501 5.305-2.942-.05-5.32-2.459-5.32-5.412V32.076l.005-.214c.113-2.92 2.534-5.34 5.476-5.304 2.763.034 5.032 2.148 5.313 4.845.03.28.258.497.539.497h7.349l.091-.008c.267-.045.468-.284.455-.563-.338-7.384-6.491-13.276-13.976-13.19zm30.98 27.579c3.104 0 5.63 2.525 5.63 5.629 0 3.104-2.526 5.629-5.63 5.629s-5.629-2.525-5.629-5.63c0-3.103 2.525-5.628 5.63-5.628z",
    transform: "translate(-526.000000, -240.000000) translate(526.000000, 240.000000)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgGrTitle);
export default __webpack_public_path__ + "static/media/img-gr-title.ee5fc12b114318142cbbda831ecf984e.svg";
export { ForwardRef as ReactComponent };